import { defineListenerProp, pickProps } from "../utils/components.mjs";
import { stickyProps } from "../sticky/index.mjs";
const props = {
  active: {
    type: [String, Number],
    default: 0
  },
  layoutDirection: {
    type: String,
    default: "horizontal"
  },
  itemDirection: {
    type: String,
    default: "horizontal"
  },
  fixedBottom: Boolean,
  activeColor: String,
  inactiveColor: String,
  disabledColor: String,
  color: String,
  indicatorColor: String,
  indicatorSize: [String, Number],
  elevation: {
    type: [Boolean, String, Number],
    default: false
  },
  scrollable: {
    type: String,
    default: "auto"
  },
  indicatorPosition: {
    type: String,
    default: "normal"
  },
  safeArea: Boolean,
  sticky: Boolean,
  stickyCssMode: pickProps(stickyProps, "cssMode"),
  stickyZIndex: pickProps(stickyProps, "zIndex"),
  offsetTop: pickProps(stickyProps, "offsetTop"),
  onClick: defineListenerProp(),
  onChange: defineListenerProp(),
  "onUpdate:active": defineListenerProp()
};
export {
  props
};
